(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-link-boxes"] && !Shopify.designMode) return;
  try {
    
  // You can include JavaScript for interactivity if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-shop-look"] && !Shopify.designMode) return;
  try {
    
  // You can include JavaScript for interactivity if needed

  } catch(e) { console.error(e); }
})();
})();
